export const displayingAddressKeys = ['address1', 'apt', 'city', 'province', 'countryRef', 'postalCode'];
